import { Container, Box, Grid, GridItem, Text } from '@chakra-ui/react';
import ExternalCandidateLightLP from '../Forms/ExternalCandidateLightLP';
import ImageShimmer from '../ImageShimmer/ImageShimmer';

interface StoryProps {
  story: {
    name: string;
    title: string;
    text: string;
    image: string;
  };
  countryOptions?: {
    name: string;
    image: string;
  }[];
  skillsOptions?: string[];
  theme: {
    green100?: string;
    green200?: string;
    green300?: string;
    blue100?: string;
    blue200?: string;
    blue300?: string;
    yellow100?: string;
    yellow200?: string;
    yellow300?: string;
    red100?: string;
  };
  variant?: string | string[];
  thankYouUrl?: string;
}

export default function StoryWithSignup({
  story,
  countryOptions,
  skillsOptions,
  theme,
  variant,
  thankYouUrl,
}: StoryProps) {
  return (
    <Box bgColor="grey.100" py={{ base: '12', lg: '20' }} id="success-stories">
      <Container>
        <Grid
          templateColumns={{
            lg: '1fr 1fr',
          }}
          gap={{ base: '16', lg: '10rem' }}
        >
          <GridItem>
            <Box textAlign="center">
              <ImageShimmer
                src={story.image}
                alt={story.name}
                width="490"
                height="344"
                style={{ objectFit: 'contain' }}
                layout="intrinsic"
              />
            </Box>
            {variant !== '1' && (
              <>
                <Text
                  mt={{ base: '4', xl: '2.625rem' }}
                  fontWeight={{ lg: 'semibold' }}
                  fontSize={{ base: '1.125rem', xl: '1.75rem' }}
                  lineHeight={{ base: '1.5rem', xl: '2.125rem' }}
                >
                  {story.text}
                </Text>
                <Box w="100%" h="px" bgColor="grey.400" my={{ base: '4', lg: '6' }} />
                <Box
                  fontWeight="semibold"
                  fontSize={{ base: '1rem', xl: '1.5rem' }}
                  lineHeight={{ base: '1.25rem', xl: '1.75rem' }}
                >
                  {story.name}
                </Box>
                <Box
                  fontSize={{ base: '1rem', xl: '1.125rem' }}
                  lineHeight={{ base: '1.25rem', xl: '1.5rem' }}
                >
                  {story.title}
                </Box>
              </>
            )}
          </GridItem>
          <GridItem>
            {variant !== '1' && (
              <ExternalCandidateLightLP
                title="Sign up"
                text="Over 80% of Terminal candidates accepted offers from our partner-companies - you could be one of those in just a few weeks time."
                thankYouUrl={thankYouUrl}
                countryOptions={countryOptions}
                skillsOptions={skillsOptions}
                theme={theme}
              />
            )}
            {variant === '1' && (
              <>
                <Text
                  mt={{ base: '4', xl: '2.625rem' }}
                  fontWeight={{ lg: 'semibold' }}
                  fontSize={{ base: '1.125rem', xl: '1.75rem' }}
                  lineHeight={{ base: '1.5rem', xl: '2.125rem' }}
                >
                  {story.text}
                </Text>
                <Box w="100%" h="px" bgColor="grey.400" my={{ base: '4', lg: '6' }} />
                <Box
                  fontWeight="semibold"
                  fontSize={{ base: '1rem', xl: '1.5rem' }}
                  lineHeight={{ base: '1.25rem', xl: '1.75rem' }}
                >
                  {story.name}
                </Box>
                <Box
                  fontSize={{ base: '1rem', xl: '1.125rem' }}
                  lineHeight={{ base: '1.25rem', xl: '1.5rem' }}
                >
                  {story.title}
                </Box>
              </>
            )}
          </GridItem>
        </Grid>
      </Container>
    </Box>
  );
}
